
export const availableFields = [
  { key: 'total_facture', label: 'M² Facture' },
  { key: 'total_occupe', label: 'M² Occupé' },
  { key: 'total_entreposage', label: 'Entreposage' },
  { key: 'total_manutation', label: 'Manutention' },
  { key: 'total_entreManu', label: 'Entrep + Manut' },
  { key: 'ttc_entreposage', label: 'TTC Entreposage' },
  { key: 'ttc_manutation', label: 'TTC Manutention' },
];

export const availableFieldsRapPeriode = [
  { key: 'total_pleins', label: '#Plein' },
  { key: 'total_litres', label: 'Qté' },
  { key: 'total_distance', label: 'Dist.(Km)' },
  { key: 'total_kilometrage', label: 'Km actuel' },
  { key: 'total_consom', label: 'Cons./100km' },
  { key: 'total_montant_cdf', label: 'Montant CDF' },
  { key: 'total_montant_usd', label: 'Montant USD' },
];
